import { api, BASE_URL } from "../config";

const TEMPLATE_URL = BASE_URL + "criterion-templates/";

export function get_all_templates() {
    return api.get(TEMPLATE_URL).then((res) => res.data);
}

export function get_templates_by_client(client_id) {
    return api.get(`${TEMPLATE_URL}client/${client_id}`).then((res) => res.data);
}

export function get_template(template_id) {
    return api.get(`${TEMPLATE_URL}${template_id}`).then((res) => res.data);
}

export function create_template(data) {
    return api.post(TEMPLATE_URL, data).then((res) => res.data);
}

export function update_template(template_id, data) {
    return api.put(`${TEMPLATE_URL}${template_id}`, data).then((res) => res.data);
}

export function delete_template(template_id) {
    return api.delete(`${TEMPLATE_URL}${template_id}`).then((res) => res.data);
}

export function add_criterion_to_template(template_id, criterion_id) {
    return api
        .post(`${TEMPLATE_URL}${template_id}/add-criterion/${criterion_id}`)
        .then((res) => res.data);
}

export function remove_criterion_from_template(template_id, criterion_id) {
    return api
        .delete(`${TEMPLATE_URL}${template_id}/remove-criterion/${criterion_id}`)
        .then((res) => res.data);
}


